import {
    forwardRef,
    useImperativeHandle,
    useState,
} from 'react'

import {
    Country,
    State,
    City,
} from 'country-state-city'

const countries = Country.getAllCountries()

const usStates = State.getStatesOfCountry("US")

const LocationOfResidenceInput = forwardRef(({ data }, ref) => {

    const [selectedCountry, setSelectedCountry] = useState(data?.country ?? "United States")
    const [selectedState, setSelectedState] = useState(usStates.find(usState => usState.name === data?.state)?.isoCode)
    const [selectedCity, setSelectedCity] = useState(data?.city)

    const [countryError, setCountryError] = useState()
    const [stateError, setStateError] = useState()
    const [cityError, setCityError] = useState()

    useImperativeHandle(ref, () => ({
        validateAndGetData: () => {

            const isCountryValid = countries.some((country => country.name === selectedCountry))

            let isValid = isCountryValid

            if (!isValid) {
                setCountryError(true)
            }

            if (isValid && selectedCountry === "United States") {
                isValid = selectedState ? true : false
                if (!isValid) {
                    setStateError(true)
                }
                if (isValid) {
                    isValid = City.getCitiesOfState("US", selectedState).length === 0 || selectedCity
                    if (!isValid) {
                        setCityError(true)
                    }
                }
            }

            const value = {
                country: selectedCountry,
                state: usStates.find(usState => usState.isoCode === selectedState)?.name,
                city: selectedCity,
            }

            return {
                isValid,
                value,
            }
        },
    }))

    return (
        <div ref={ref} >

            <div className="w-ful text-center">

                <div className="text-left">
                    <label
                        className="block text-sm text-gray-800 mb-2"
                        htmlFor='country'
                    >
                        Country
                    </label>
                    <select
                        id="country"
                        name="country"
                        className="border border-gray-300 rounded-md p-2 bg-white w-full"
                        value={selectedCountry}
                        onChange={e => {
                            setSelectedCountry(e.target.value)
                            setSelectedState(undefined)
                            setSelectedCity(undefined)
                        }}
                    >
                        <option value="">Select Country</option>
                        {countries.map(country => (
                            <option key={country.name} value={country.name}>
                                {country.name}
                            </option>
                        ))}
                    </select>

                    {countryError && (
                        <p className="text-sm text-red-600 mt-2">Please select country</p>
                    )}

                </div>

                {
                    selectedCountry === "United States" && (

                        <>
                            < div className="text-left mt-6">
                                <label
                                    className="block text-sm text-gray-800 mb-2"
                                    htmlFor='state'
                                >
                                    State
                                </label>
                                <select
                                    id="state"
                                    name="state"
                                    className="border border-gray-300 rounded-md p-2 bg-white w-full"
                                    value={selectedState}
                                    onChange={e => {
                                        setSelectedState(e.target.value)
                                        setSelectedCity(undefined)
                                    }}
                                >
                                    <option value="">Select State</option>
                                    {usStates.map(state => (
                                        <option key={state.isoCode} value={state.isoCode}>
                                            {state.name}
                                        </option>
                                    ))}
                                </select>

                                {stateError && (
                                    <p className="text-sm text-red-600 mt-2">Please select state</p>
                                )}

                            </div>

                            {
                                City.getCitiesOfState("US", selectedState).length > 0 && (
                                    < div className="text-left mt-6">
                                        <label
                                            className="block text-sm text-gray-800 mb-2"
                                            htmlFor='city'
                                        >
                                            City
                                        </label>
                                        <select
                                            id="city"
                                            name="city"
                                            className="border border-gray-300 rounded-md p-2 bg-white w-full"
                                            value={selectedCity}
                                            disabled={!selectedState}
                                            onChange={e => {
                                                setSelectedCity(e.target.value)
                                            }}
                                        >
                                            <option value="">Select City</option>
                                            {City.getCitiesOfState("US", selectedState).map(city => (
                                                <option key={city.name} value={city.name}>
                                                    {city.name}
                                                </option>
                                            ))}
                                        </select>

                                        {cityError && (
                                            <p className="text-sm text-red-600 mt-2">Please select city</p>
                                        )}

                                    </div>
                                )
                            }

                        </>
                    )
                }

            </div>
        </div >
    )

})

export default LocationOfResidenceInput
